import { api } from '../../../../../lib';
import { CadastrosContractUser } from '../SetupIpaPricingResponsibilities/types';
import { EngineUpdateCandidateUser, EngineUpdateNotificationSettings } from './types';

const ENGINE_UPDATE_NOTIFICATIONS_URL = '/setup/engine-update-notifications';

// T05a (IPA-10850), respondida na homologação: o acesso ao IPA é o serviço de nome "IPA" na lista
// `servicos` que a API de cadastro devolve por usuário.
export const IPA_SERVICE_NAME = 'IPA';

const getClientId = () => JSON.parse(localStorage.getItem('cliente') ?? '{}')?.codigo;

// Função NOVA (IPA-10850, AC-F5): reaproveita o mesmo endpoint de cadastro de usuários do cliente
// usado por `getActiveIpaUsers` (SetupIpaPricingResponsibilities/service.ts), mas preserva os
// campos de administrador e de serviços contratados da resposta bruta — NÃO altera aquela função,
// que já tem um consumidor com teste próprio (o modal de responsáveis pela precificação).
export async function getContractUsersForEngineUpdate(): Promise<CadastrosContractUser[]> {
  const response = await api.get<CadastrosContractUser[]>(`${process.env.REACT_APP_CADASTROS_API_URL}/contratos/usuarioServicos`, {
    expectToken: true,
    params: {
      cliente: getClientId(),
      query: '',
    },
  });

  return response.data;
}

// RN12 (IPA-10850): só quem tem acesso ao IPA é candidato a destinatário; preserva `administrador`
// (null tratado como false) e ordena alfabeticamente por nome.
export function mapContractUsersToEngineUpdateCandidates(rawUsers: CadastrosContractUser[]): EngineUpdateCandidateUser[] {
  return rawUsers
    .filter(rawUser => (rawUser.servicos ?? []).some(servico => servico.name === IPA_SERVICE_NAME))
    .map(rawUser => ({
      cdUsuario: rawUser.usuario.codigo,
      name: rawUser.usuario.nome,
      email: rawUser.usuario.login,
      isAdmin: !!rawUser.administrador,
    }))
    .sort((left, right) => left.name.localeCompare(right.name, 'pt-BR', { sensitivity: 'base' }));
}

export async function getEngineUpdateNotificationSettings(): Promise<EngineUpdateNotificationSettings | null> {
  const response = await api.get<EngineUpdateNotificationSettings>(ENGINE_UPDATE_NOTIFICATIONS_URL, {
    expectToken: true,
    validateStatus: status => status === 200 || status === 204 || status === 404,
  });

  return response.status === 200 ? response.data : null;
}

export async function saveEngineUpdateNotificationSettings(settings: EngineUpdateNotificationSettings): Promise<EngineUpdateNotificationSettings> {
  const response = await api.put<EngineUpdateNotificationSettings>(ENGINE_UPDATE_NOTIFICATIONS_URL, settings, { expectToken: true });
  return response.data;
}
